import React, { useState } from 'react';
import {useTranslation} from "react-i18next";

const Dropdown = ({onChange}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('10');
  const {t} = useTranslation();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (option) => {
    setSelected(option);
    onChange(option);
    setIsOpen(false);
  };

  const options = ['10', '20', '30'];

  return (
    <div className="relative inline-block text-left mt-1">
      <div className={"flex items-center"}>
        <span className={"text-[11px] text-gray-900"}>{t("show")}</span>
        <button
          onClick={toggleDropdown}
          className="mx-2 inline-flex  h-[32px] w-[50px] rounded-md border border-gray-300 shadow-sm flex justify-center py-2 bg-transparent text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          id="options-menu"
          aria-expanded={isOpen}
          aria-haspopup="true"
        >
          {selected}
          <svg
            className="mr-1  h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06 0L10 10.5l3.71-3.29a.75.75 0 111.04 1.08l-4.25 3.5a.75.75 0 01-1.04 0l-4.25-3.5a.75.75 0 010-1.08z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div className={"text-[11px] text-gray-900 "}>{t("page")}</div>
      </div>

      {isOpen && (
        <div
          className="absolute right-16 z-10 mt-2 w-35 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <div className="py-1" role="none">
            {options.map((option) => (
              <button
                key={option}
                onClick={() => handleSelect(option)}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                role="menuitem"
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
